$(document).ready(function(){
  $(".custom_banner .page-width .wrapper .banner_btn, section.custom_percentage .wrapper .left_block .section_btn, .custom_footer_banner .page-width .wrapper .banner_btn ").on("click", function(e){
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $(".custom_featured_product").offset().top
    }, 600, "swing"); // smooth scroll (600ms duration, swing easing)
  });
});
document.querySelectorAll('.landing_page_banner .banner_btn, .custom_image_text_2 .banner_btn, .half_image_text .banner_btn, .use_of_lunee .banner_btn, .image_text_faq .banner_btn, .lpd_two_banner_section .banner_btn')
  .forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.custom_featured_product').scrollIntoView({
        behavior: 'smooth'
      });
    });
  });

document.querySelectorAll('.lpd_two_banner_section .banner_btn, .lpd_two_image_with_text .banner_btn, .lpd_two_text_with_image .banner_btn, .image_with_ioon_text .banner_btn, .lpd_two_testimonail .banner_btn, .custom_image_lpd_two .banner_btn, .lpd_two_trusted_images .banner_btn, .use_of_lunee_lpd_two .banner_btn')
  .forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.lpd_two_custom_featured_product').scrollIntoView({
        behavior: 'smooth'
      });
    });
  });


  document.querySelectorAll('.custom-banner-content-cta-button')
  .forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.lpd_one_custom_featured_product').scrollIntoView({
        behavior: 'smooth'
      });
    });
  });



// custom_featured_product js
$(document).on('click', '.custom_featured_product .add-to-cart-btn, .lpd_one_custom_featured_product .add-to-cart-btn, .lpd_two_custom_featured_product .add-to-cart-btn, .eascStickyAddToCartBar .eascStickyAddToCartBtn', function (e) {
  e.preventDefault();

  const $btn = $(this);
  if ($btn.prop('disabled')) return;

  $btn.prop('disabled', true);

  const $product = $btn.closest('.custom_featured_product, .lpd_one_custom_featured_product, .lpd_two_custom_featured_product ');
  const variantId = $product.find('.cus_btn_var_id').val();  
  const planId = $product.find('.selling_plan_cus').val(); 

  const data = {
    id: variantId,
    quantity: 1,
    selling_plan: planId || null
  };

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(data),
    contentType: 'application/json',
    dataType: 'json',
    success: function () {
      import('@theme/events').then(({ CartUpdateEvent }) => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const event = new CartUpdateEvent(cart, 'manual-trigger', {
              itemCount: cart.item_count,
              source: 'custom-featured',
              sections: {
                header: 'header',
                cartDrawer: 'cart-drawer'
              }
            });
            document.dispatchEvent(event);

            const cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer) cartDrawer.open();
          });
      });
    },
    error: function (xhr) {
      const res = JSON.parse(xhr.responseText);
      alert(res.description || 'Out of stock');
    },
    complete: function() {
      $btn.prop('disabled', false);
    }
  });
});



